(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eg-media-video-image"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eg-media-video')) {
    customElements.define(
      'eg-media-video',
      class EgMediaVideo extends HTMLElement {
        static observedAttributes = ['suspended'];

        connectedCallback() {
          this.video = this.querySelector(':scope > video');
          if (!this.video) return;

          const sources = [...this.video.querySelectorAll('source')];
          if (!sources.some((source) => this.video.canPlayType(source.type))) return this.fallBack();
          sources.at(-1)?.addEventListener('error', () => this.fallBack());

          this.held = false;
          const hold = (held) => () => {
            this.held = held;
            this.sync();
          };
          this.video.addEventListener('pointerdown', hold(true));
          ['pointerup', 'pointercancel', 'pointerleave'].forEach((type) =>
            this.video.addEventListener(type, hold(false))
          );
          this.video.addEventListener('contextmenu', (event) => event.preventDefault());

          /* Wait a tick: ModalDialog fires modalClosed before its own pauseAllMedia(). */
          this.resume = () => setTimeout(() => this.sync());
          document.addEventListener('visibilitychange', this.resume);
          document.body.addEventListener('modalClosed', this.resume);

          this.sync();
        }

        disconnectedCallback() {
          if (!this.resume) return;
          document.removeEventListener('visibilitychange', this.resume);
          document.body.removeEventListener('modalClosed', this.resume);
        }

        attributeChangedCallback() {
          this.sync();
        }

        sync() {
          if (!this.video?.isConnected) return;
          if (document.hidden || this.held || this.hasAttribute('suspended')) {
            this.video.pause();
          } else {
            this.video.play().catch(() => {});
          }
        }

        fallBack() {
          const img = this.querySelector(':scope > img[hidden]');
          if (!img) return;
          this.video.remove();
          img.loading = 'eager';
          img.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
